import {
  DBxEvent,
  DataQuery,
  ParserUtil
} from "cartovista";
import {drawStyleIconCanvas} from "../../utils/CvUtils";
import { Popover } from 'bootstrap';

    export default class FeatureItem {
      constructor(resultItem, feature, separateFeatures) {
        this._resultItem = resultItem;
        this.feature = feature;
        this._separateFeatures = separateFeatures ? separateFeatures : false;
        this._featureName = this._getFeatureName();
        this._styleIconCanvas = this._generateStyleIconCanvas();
        this._$resultFeatureRow = null;
        this._visible = true;
        Object.defineProperties(this, {
            "visible": {
                get: function() { return this._visible; },
                set: this._setVisibility.bind(this)
            }
        });
      }

      _setVisibility(bool){
        this._visible = bool;
        this.feature.visible = bool;
        if(this._$resultFeatureRow) this._$resultFeatureRow.find(".ResultsList_toggleVisible_input").prop("checked", bool ? "checked" : "");
      };

    _getFeatureName() {
        var name;
        new DataQuery([this._resultItem._resultList.layer.featureNameDataColumn], [this.feature.id])
            .execute(function(result) {
                name = result.values[this._resultItem._resultList.layer.featureNameDataColumn.dataTable.id][this._resultItem._resultList.layer.featureNameDataColumn.id][0];
            }, this);
        return name;
    };

    _generateStyleIconCanvas() {
        var canvas = document.createElement("canvas");
        canvas.width = 14;
        canvas.height = 14;
        drawStyleIconCanvas(canvas, this.feature.style);
        return canvas;
    };

    _generateFeatureItemRow() {
        this._$resultFeatureRow = $('<li class="list-group-item">' +
                                    '<div class="row">' +
                                        '<div class="col col-1 text-center">' +
                                            '<a class="ResultsList_zoom_link" href="javascript:void(0);" title="Zoomer"><i class="bi bi-zoom-in"></i></a>' +
                                        '</div>' +
                                        (this._separateFeatures ? '<div class="col col-1 text-center">' +
                                        '<input class="ResultsList_toggleVisible_input" type="checkbox" ' + (this.visible ? 'checked="checked"' : '') + ' title="Changer la visibilité">' +
                                    '</div>' +
                                    '<div class="col col-1 text-center" style="height:14px;">' +
                                        '<a class="ResultsList_changeColor_popover" href="javascript:void(0);" data-bs-toggle="popover"><span class="ResultsList_symbolCanvas" title="Changer la couleur"></span></a>' +
                                    '</div>' : '<div class="col col-2 text-center"></div>') + 
                                        '<div class="col col-7">' + this._featureName + '</div>' +
                                        (this._separateFeatures ? '<div class="col col-1 text-center">' +
                                        '<a class="ResultsList_dataView_link" href="javascript:void(0);" title="Voir les données"><i class="bi bi-table"></i></a>' +
                                    '</div>' +
                                    '<div class="col col-1 text-center">' +
                                        '<a class="ResultsList_delete_link" href="javascript:void(0);" title="Supprimer"><i class="bi bi-trash3"></i></a>' +
                                    '</div>' : '') +
                                    '</div>' +
                                '</li');

        this._$resultFeatureRow.find(".ResultsList_symbolCanvas").html(this._styleIconCanvas)

        this._$resultFeatureRow.mouseenter(function() {
            this._resultItem._resultList.layer.rolloverFeatures = [this.feature];
        }.bind(this));

        this._$resultFeatureRow.mouseleave(function() {
            this._resultItem._resultList.layer.rolloverFeatures = [];
        }.bind(this));

        this._$resultFeatureRow.find(".ResultsList_toggleVisible_input").click(function() {
            this.visible = !this.visible;
        }.bind(this));

        _.forEach(this._$resultFeatureRow.find(".ResultsList_changeColor_popover"), function(popover){
          new Popover(popover, {
            "template": '<div class="ResultsList_colorPicker_popover popover" role="popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>',
            "content": '<div class="ResultsList_colorPicker"></div>',
            "container": "body",
            "placement": "auto",
            "html": true,
            "trigger":"manual"
          });
        });
        this._$resultFeatureRow.find(".ResultsList_changeColor_popover").click(function(evt) {
            Popover.getInstance(evt.currentTarget).toggle();
            $("body").on("mouseup.popover", function(e) {
                if (!$(e.target).parents(".ResultsList_colorPicker_popover").length) {
                    Popover.getInstance(evt.currentTarget).hide();
                    $("body").off("mouseup.popover");
                }
            });
        });

        _.forEach(this._$resultFeatureRow.find(".ResultsList_changeColor_popover"), function(popover){
          popover.addEventListener("shown.bs.popover", function() {
              $(".ResultsList_colorPicker").kendoFlatColorPicker({
                  "value": this.feature.style.symbolizers[0].fillColor1.rgba,
                  "autoupdate": true,
                  "change": _.debounce(this._onColorPickerChanged.bind(this), 100)
              });
          }.bind(this));
        }.bind(this));

        this._$resultFeatureRow.find(".ResultsList_zoom_link").click(this._resultItem._resultList.zoomOnFeatures.bind(this._resultItem._resultList, [this.feature]));
        this._$resultFeatureRow.find(".ResultsList_dataView_link").click(this._resultItem._resultList.toggleFeatureDataView.bind(this._resultItem._resultList, [this.feature]));
        this._$resultFeatureRow.find(".ResultsList_delete_link").click(this._resultItem.removeFeatureItem.bind(this._resultItem, this));

        return this._$resultFeatureRow;
    }

    _onColorPickerChanged(obj) {
        this.feature.style.symbolizers[0].fillColor1 = ParserUtil.parseColor(obj.value);
        this.feature.dispatchEvent(new DBxEvent(this.feature.EVENTS.CONTENT_CHANGED));
        this._styleIconCanvas = this._generateStyleIconCanvas();
        this._$resultFeatureRow.find(".ResultsList_symbolCanvas").html(this._styleIconCanvas);
    };

}
